export default __webpack_public_path__ + "static/media/V_Old_Black.e4ac7797.png";